import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_calendar_week.breadcrumb.label1'),
    link: '/application',
  },
  {
    label: t('pages.application_calendar_week.breadcrumb.label2'),
    link: '/application/calendar',
  },
  {
    label: t('pages.application_calendar_week.breadcrumb.label3'),
  },
];
